import { render, staticRenderFns } from "./ERPCSettingsForm.vue?vue&type=template&id=3b5af49b"
import script from "./ERPCSettingsForm.vue?vue&type=script&lang=js"
export * from "./ERPCSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports